import { LogOut, ArrowLeftRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { useAuthStore } from "@/store/auth-store";
import { AdminAPI } from "@/lib/admin-api";
import { Badge } from "@/components/ui/Badge";

export function AdminTopbar() {
  const { user, logout } = useAuthStore();
  const nav = useNavigate();
  
  const health = useQuery({
    queryKey: ["admin-health"],
    queryFn: AdminAPI.health,
    refetchInterval: 30_000,
  });

  return (
    <header className="h-16 sticky top-0 z-30 bg-white/80 backdrop-blur border-b border-surface-200 px-6 flex items-center justify-between shadow-sm">
      
      {/* Left Side (Breadcrumb/Greeting) */}
      <div className="flex flex-col justify-center">
        <div className="text-[11px] uppercase font-bold text-surface-400 tracking-wider">System Administrator</div>
        <div className="text-sm font-bold text-surface-900 truncate max-w-[200px]">{user?.full_name}</div>
      </div>
      
      {/* Right Side Actions */}
      <div className="flex items-center gap-3">
        {/* Health Badges (Hidden on very small screens if they ever show up) */}
        <div className="hidden md:flex items-center gap-2">
          {health.data && (
            <Badge tone={health.data.database === "ok" ? "success" : "danger"} className="shadow-sm">
              DB: {health.data.database.toUpperCase()}
            </Badge>
          )}
          {health.data && health.data.outbox_dlq > 0 && (
            <Badge tone="danger" className="shadow-sm animate-pulse">
              DLQ: {health.data.outbox_dlq}
            </Badge>
          )}
        </div>
        
        {/* Switch to Customer View */}
        <button 
          onClick={() => nav("/")}
          className="text-xs text-brand-600 hover:text-brand-700 font-bold bg-brand-50 hover:bg-brand-100 px-3 py-1.5 rounded-lg inline-flex items-center gap-1.5 transition-colors border border-brand-200"
        >
          <ArrowLeftRight className="h-3.5 w-3.5" /> Customer View
        </button>
        
        <div className="h-8 w-px bg-surface-200 mx-1" />
        
        {/* Profile & Logout */}
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-gradient-to-br from-surface-700 to-surface-900 grid place-items-center text-white text-sm font-bold shadow-md">
            {user?.full_name.charAt(0)}
          </div>
          <div className="hidden xl:block">
            <div className="text-sm font-bold text-surface-900 leading-tight capitalize truncate max-w-[120px]">
              {user?.role.replace(/_/g, " ")}
            </div>
            <div className="text-[10px] text-surface-500 font-mono truncate">{user?.user_id}</div>
          </div>
          <button 
            onClick={() => { logout(); nav("/login"); }}
            className="h-9 w-9 flex items-center justify-center rounded-lg bg-white border border-surface-200 hover:bg-danger-50 hover:text-danger-600 hover:border-danger-200 text-surface-500 shadow-sm transition-all"
            title="Logout"
          >
            <LogOut className="h-4 w-4" />
          </button>
        </div>
      </div>
    </header>
  );
}